import React, { useState } from "react";
import { Button, Form, Col, Table, Container, Row } from "react-bootstrap";

import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import AddressModal from "./toolbox/AddressModal";
import { getBaseURL } from "./api/api";

const downloadFile = (url, defaultFilename) => {
  fetch(url)
    .then((res) => res.blob())
    .then((blob) => {
      const u = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = u;
      a.download = defaultFilename;
      a.click();
      window.URL.revokeObjectURL(u);
    })
    .catch(() => toast.error("Download failed."));
};

function AdminAddressUpload() {
  const [file, setFile] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);

  // FIXME if you browse for a file but not select it and click somewhere else, app crashes
  const uploadFile = (e) => {
    e.preventDefault();
    if (file.size > 0) {
      const data = new FormData();
      data.append("file", file);
      const res = axios.post(`${getBaseURL()}/uploadAddresses`, data, {
        headers: {
          "content-type": "multipart/form-data",
        },
      });
      toast.promise(res, {
        pending: "Uploading address...",
        success: "Address uploaded successfully.",
        error: "Address uploaded failed. Please try again!",
      });
      //console.log(res);
      setFile();
    }
  };
  const fileHandler = (e) => {
    setFile(e.target.files[0]);
    setIsDisabled(false);
  };
  return (
    <Container style={{ marginTop: "110px" }}>
      <ToastContainer />
      <form onSubmit={uploadFile} encType="multipart/form-data">
        <Form.Row>
          <Form.Group as={Col} controlId="uploadFile">
            <Form.Text id="passwordHelpBlock" muted>
              You can browse or drag and drop an Excel file (.xlsx) to upload
              address data.
            </Form.Text>
            <Form.File
              className="col-md-6"
              id="filePath"
              label={file?.name || ""}
              onChange={fileHandler}
              custom
            />
          </Form.Group>
        </Form.Row>
        <Row className="mt-3">
          <Col>
            <Button type="submit" variant="primary" className="mr-3">
              Upload
            </Button>
            <Button
              variant="secondary"
              onClick={() => setShowModal(true)}
            >
              Add Single Address
            </Button>
          </Col>
        </Row>
      </form>

      <AddressModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onSave={async (addressData) => {
          try {
            const response = await fetch(`${getBaseURL()}/v1/addresses`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                ...addressData,
                address: addressData.address.toUpperCase(),
              }),
            });

            if (!response.ok) {
              const text = await response.text();
              let errorMessage;
              try {
                const errorData = JSON.parse(text);
                errorMessage = errorData.message;
              } catch (e) {
                errorMessage = text;
              }
              if (response.status === 409) {
                throw new Error('This address already exists in the database');
              }
              throw new Error(errorMessage || 'Failed to add address');
            }

            toast.success('Address added successfully!');
            setShowModal(false);
            // Optionally refresh the address list here if needed
          } catch (error) {
            toast.error(error.message || 'Error adding address');
          }
        }}
      />
      <br />
      <br />
      <strong>SAMPLE EXCEL FILE FORMAT</strong>
      <Table id="adminSearch" striped bordered hover>
        <thead>
          <tr>
            <th key="number">Number</th>
            <th key="address">Street</th>
            <th key="SLH">Shaker Lane School</th>
            <th key="RSS">Russell Street School</th>
            <th key="LMS">Littleton Middle School</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td key="0">1</td>
            <td key="1">ABENAKI TRAIL</td>
            <td key="2">4.8</td>
            <td key="3">3.1</td>
            <td key="4">2.9</td>
          </tr>
        </tbody>
      </Table>
      <Button
        variant="primary"
        className="m-1"
        onClick={() =>
          downloadFile(`${getBaseURL()}/addresses/export`, "addresses.xlsx")
        }
      >
        Download all data
      </Button>
      <Button
        variant="outline-primary"
        className="m-1"
        onClick={() =>
          downloadFile(`${getBaseURL()}/addresses/sample`, "address-sample.xlsx")
        }
      >
        Download sample
      </Button>
    </Container>
  );
}
export default AdminAddressUpload;
